const FOCUSSABLE_SELECTOR =
  'a[href]:not([disabled]), area[href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';

const isVisible = (el) => (
  typeof el.checkVisibility === 'function' ? el.checkVisibility() : el.offsetParent !== null
);

const trapFocus = (element) => {
  element.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;

    // Resolved on every keydown — the drawers this wraps re-render their
    // content. Controls hidden at the current breakpoint (or inside a hidden
    // block) can never hold focus, so they must not bound the trap.
    const focusableElements = [...element.querySelectorAll(FOCUSSABLE_SELECTOR)].filter(isVisible);
    if (!focusableElements.length) return;

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === lastFocusableElement) {
      firstFocusableElement.focus();
      e.preventDefault();
    }
  });
};

export default trapFocus;
